import useAppDispatch from './../useAppDispatch'
import { openDialog as openDialogAction } from '../../redux/slices/config'
import { IOpenLimitDialogArgs } from '../../interfaces/actions'
import {
  CinnamonActionNames,
  TextLibrary,
} from '../../consts/defaultConfigValues/defaultConstants'
import { useAppSelector } from '../useAppSelector'

const useLimitFreegoodsSelection = () => {
  const dispatch = useAppDispatch()
  const products = useAppSelector(
    (state) =>
      state.catalogSlice.freegoodsConf.quantitySelection?.products ?? [],
  )
  const openLimitDialog = ({ sku, newValue }: IOpenLimitDialogArgs) => {
    const currentProduct = products.find((product) => product.sku === sku)
    const isStockLimitReached =
      typeof currentProduct?.stock === 'number' &&
      newValue > currentProduct?.stock

    dispatch(
      openDialogAction({
        icon: { name: 'MdCheck' },
        title: {
          value: isStockLimitReached
            ? TextLibrary.PRODUCT_STOCK_TITLE
            : TextLibrary.PRODUCT_PROMOTION_LIMIT_TITLE,
        },
        buttons: [
          {
            label: TextLibrary.ACTIONS_ACCEPT,
            actions: {
              cinnamonActions: [
                {
                  name: CinnamonActionNames.CLOSE_DIALOG,
                },
              ],
            },
          },
        ],
        message: {
          value: isStockLimitReached
            ? TextLibrary.PRODUCT_STOCK_MESSAGE
            : TextLibrary.PRODUCT_PROMOTION_LIMIT_MESSAGE,
        },
      }),
    )
  }

  return { openLimitDialog }
}

export default useLimitFreegoodsSelection
